export default __webpack_public_path__ + "static/media/linkedin.fff99902.svg";